export default "__VITE_PUBLIC_ASSET__9f45e39c__"